import { 
    CreateInvoiceDto, 
    DeleteInvoiceDto,
    EditInvoiceDto,
    GetInvoiceDto, 
    InvoiceApiFp,
    InvoiceControllerGet200Response,
    MessageResponseDto, 
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseInvoiceModel = InvoiceControllerGet200Response;
export type GetInvoiceModel = GetInvoiceDto;
export type MutateResponseInvoiceModel = MessageResponseDto;
export type CreateInvoiceModel = CreateInvoiceDto;
export type UpdateInvoiceModel = EditInvoiceDto;
export type DeleteInvoiceModel = DeleteInvoiceDto;

export const apiInvoiceFp = InvoiceApiFp(apiConfig);
export const getInvoiceController = apiInvoiceFp.invoiceControllerGet;
export const createInvoiceController = apiInvoiceFp.invoiceControllerCreate;
export const updateInvoiceController = apiInvoiceFp.invoiceControllerEdit;
export const deleteInvoiceController = apiInvoiceFp.invoiceControllerDelete;

export const QueryKeyInvoice = QueryKey.Invoice;